module.exports = __webpack_public_path__ + "media/images/icon_notice_l-d82ce741d77049b05b7dd9e174b646fa.svg";